import React, {useEffect} from 'react';
import {
  Image,
  ImageBackground,
  TouchableOpacity,
  View,
  TouchableWithoutFeedback,
  Keyboard,
  KeyboardAvoidingView,
  Platform,
} from 'react-native';
import AgreeNegotiate, {
  AgreeNegotiateRef,
} from '../AViewComponents/AgreeNegotiate/AgreeNegotiate';
import {createStyles} from '../../utils/createStyles';
import {Avatar, Button, Input} from '@rneui/themed';
import LinearGradient from 'react-native-linear-gradient';
import {Controller, useForm} from 'react-hook-form';
import {loginApi} from '../../API/user';
import useGetDeviceInfo from '../../hooks/useGetDeviceInfo';
import Toast from 'react-native-toast-message';
import {saveUserInfo, selectUserInfo} from '../../store/user';
import {useDispatch, useSelector} from 'react-redux';
import {CommonActions, useNavigation, useRoute} from '@react-navigation/native';
import {RouteProp} from '@react-navigation/core/src/types';
import {RouteParamsList} from '../../router/ParamsList';
import {useAppSelector} from '../../store/hooks';

type Inputs = {
  mobile: string;
  password: string;
};

export default function AppLogin(): React.JSX.Element {
  const navigation = useNavigation();
  const route = useRoute<RouteProp<RouteParamsList, 'Login'>>();
  const checkRef = React.useRef<AgreeNegotiateRef | null>(null);
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  const {uniqueId} = useGetDeviceInfo();
  const userInfo = useAppSelector(selectUserInfo); // 用户信息
  const {control, handleSubmit, setValue, formState} = useForm({
    reValidateMode: 'onSubmit',
  });
  const formProps = {
    mobile: {
      control,
      name: 'mobile',
      rules: {
        required: {
          value: true,
          message: '请输入手机号',
        },
        pattern: {
          value: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
          message: '手机号格式不正确',
        },
      },
    },
    password: {
      control,
      name: 'password',
      rules: {
        required: {
          value: true,
          message: '请输入密码',
        },
      },
    },
  };

  useEffect(() => {
    if (route.params?.mobile) {
      setValue('mobile', route.params?.mobile);
    }
  }, [route.params?.mobile, setValue]);

  // 显示错误
  useEffect(() => {
    const {errors} = formState;
    Object.keys(errors).some(k => {
      if (errors[k]?.message) {
        Toast.show({
          type: 'error',
          text1: errors[k]?.message as string,
        });
      }
      return errors[k]?.message;
    });
  }, [formState]);

  const onSubmit = (data: Inputs) => {
    if (!checkRef.current?.getCheckState()) {
      return Toast.show({
        type: 'info',
        text1: '请先阅读并同意用户协议',
      });
    }
    setLoading(true);
    // 提交
    loginApi({
      mobile: data.mobile,
      deviceSn: uniqueId,
      password: data.password,
    }).then(res => {
      console.log(res, uniqueId);
      if (res.status === 200) {
        dispatch(saveUserInfo(res.data));
        if (res.data.curriculumSetup.xkwGradeId) {
          setTimeout(() => {
            setLoading(false);
            // @ts-ignore
            // navigation.replace('ChatGPTAssist');
            navigation.dispatch(
              CommonActions.reset({
                index: 0,
                routes: [{name: 'ChatGPTAssist'}],
              }),
            );
          }, 1000);
        } else {
          // @ts-ignore
          navigation.dispatch(
            CommonActions.reset({
              index: 0,
              routes: [
                {name: 'Register', params: {isEdit: true, showModal: true}},
              ],
            }),
          );
        }
      } else {
        Toast.show({
          type: 'error',
          text1: res.msg as string,
        });
        setLoading(false);
      }
    });
  };
  const toRegister = () => {
    // @ts-ignore
    navigation.navigate('Register');
  };
  const toForgetPassword = () => {
    // @ts-ignore
    navigation.navigate('ForgetPassword');
  };
  return (
    <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
      <KeyboardAvoidingView
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        style={styles.flex1}>
        <ImageBackground
          style={styles.flex1}
          source={require('../../assets/images/bg1.png')}>
          <TouchableOpacity
            onLongPress={() => navigation.navigate('SysSetting')}
            delayLongPress={5000}
            style={styles.settingButton}
          />
          <View style={styles.center}>
            <View style={styles.loginWrap}>
              {/*头像*/}
              <Avatar
                containerStyle={styles.avatar}
                size={64}
                rounded
                imageProps={{
                  resizeMode: 'cover',
                }}
                avatarStyle={{width: '100%', height: '100%'}}
                source={require('../../assets/images/av.png')}
              />
              {/*手机号*/}
              <View style={styles.inputWrap}>
                <Image
                  style={styles.inputImg}
                  source={require('../../assets/images/phone-call.png')}
                />
                <Controller
                  {...formProps.mobile}
                  render={({field: {onChange, onBlur, value}}) => (
                    <Input
                      onBlur={onBlur}
                      value={value}
                      onChangeText={onChange}
                      style={styles.textInput}
                      containerStyle={styles.input}
                      inputContainerStyle={{borderBottomWidth: 0}}
                      placeholder="请输入手机号码"
                    />
                  )}
                />
              </View>
              {/*密码*/}
              <View style={{...styles.inputWrap, ...styles.inputWrapLock}}>
                <Image
                  style={styles.inputImg}
                  source={require('../../assets/images/lock.png')}
                />
                <Controller
                  {...formProps.password}
                  render={({field: {onChange, onBlur, value}}) => (
                    <Input
                      onBlur={onBlur}
                      value={value}
                      onChangeText={onChange}
                      style={styles.textInput}
                      secureTextEntry={true}
                      containerStyle={styles.input}
                      inputContainerStyle={{borderBottomWidth: 0}}
                      placeholder="请输入登录密码"
                    />
                  )}
                />
              </View>
              {/*注册*/}
              <View style={styles.forgetBts}>
                <Button
                  buttonStyle={styles.forgetBt}
                  titleStyle={styles.forgetBtText}
                  size={'sm'}
                  title="注册账号"
                  type="clear"
                  onPress={toRegister}
                />
                <View style={styles.line} />
                <Button
                  buttonStyle={styles.forgetBt}
                  titleStyle={styles.forgetBtText}
                  activeOpacity={0.2}
                  size={'sm'}
                  title="忘记密码"
                  type="clear"
                  onPress={toForgetPassword}
                />
              </View>
              {/*登录*/}
              <Button
                loading={loading}
                loadingProps={{size: 35}}
                onPress={handleSubmit(onSubmit as any)}
                containerStyle={styles.loginBtWrap}
                buttonStyle={styles.loginBt}
                ViewComponent={LinearGradient} // Don't forget this!
                linearGradientProps={{
                  style: {height: 100, flex: 1},
                  colors: ['#9E99FF', '#6455FF'],
                  start: {x: 0, y: 0.5},
                  end: {x: 1, y: 0.5},
                }}>
                <Image
                  resizeMode={'contain'}
                  style={styles.loginBtImg}
                  source={require('../../assets/images/98.png')}
                />
              </Button>
            </View>
            <View style={styles.AgreeNegotiate}>
              <AgreeNegotiate ref={checkRef} />
            </View>
          </View>
        </ImageBackground>
      </KeyboardAvoidingView>
    </TouchableWithoutFeedback>
  );
}
const styles = createStyles({
  flex1: {
    flex: 1,
    position: 'relative',
  },
  settingButton: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '5rem',
    height: '5rem',
    zIndex: 100,
  },
  center: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  avatar: {
    marginBottom: '6.25rem',
  },
  inputWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '26rem',
    height: '4.2rem',
    paddingLeft: '1rem',
    fontSize: '1.56rem',
    borderWidth: 1,
    borderRadius: '4rem',
    borderColor: '#333333',
  },
  inputWrapLock: {
    marginTop: '1.8rem',
  },
  inputImg: {
    width: '2rem',
    height: '2rem',
  },
  textInput: {
    fontSize: '1.56rem',
  },
  input: {
    height: '100%',
    flex: 1,
  },
  loginWrap: {
    alignItems: 'center',
  },
  forgetBts: {
    width: '26rem',
    marginTop: '1rem',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  forgetBt: {},
  forgetBtText: {
    fontSize: '1.04rem',
    color: '#666666',
  },
  line: {
    height: '0.6rem',
    backgroundColor: '#666666',
    width: 1,
  },
  loginBtWrap: {
    marginTop: '6.98rem',
  },
  loginBt: {
    width: '16.92rem',
    height: '6.25rem',
    borderRadius: '3.39rem',
  },
  loginBtImg: {
    height: '100%',
    width: '3.07rem',
  },
  AgreeNegotiate: {
    marginTop: '5.02rem',
    marginBottom: '3rem',
  },
});
